import UploadList from './UploadList.js';

export default UploadList;


